const mockAdmin = [
    {
      id: 1,
      name: "АЗК Z-27",
      barcode: "1112223334445",
      status: "ERROR",
      statusLabel: "Отклонен",
      adress: "г. Астана, ул. Абая, 25",
      createdAt: "2024-03-07",
      deliveryDate: "2024-03-20",
      data: [
        {
          id: 1,
          name: "Сникерс",
          barcode: "1112223330001",
          total: 50,
          dateTime: "2024-03-15T09:45:00Z"
        },
        {
          id: 2,
          name: "Кока-Кола 1л",
          barcode: "1112223330002",
          total: 30,
          dateTime: "2024-03-15T10:00:00Z"
        },
        {
          id: 3,
          name: "Чипсы Lays",
          barcode: "1112223330003",
          total: 40,
          dateTime: "2024-03-15T10:15:00Z"
        }
      ]
    },
    {
      id: 2,
      name: "АЗК Z-26",
      barcode: "9876543210987",
      status: "ERROR",
      statusLabel: "Возврат",
      adress: "г. Астана, пр. Туран, 50",
      createdAt: "2024-03-05",
      deliveryDate: "2024-03-15",
      data: [
        {
          id: 4,
          name: "Шоколад Alpen Gold",
          barcode: "9876543210001",
          total: 25,
          dateTime: "2024-03-12T15:30:00Z"
        },
        {
          id: 5,
          name: "Сок Добрый 1л",
          barcode: "9876543210002",
          total: 35,
          dateTime: "2024-03-12T15:45:00Z"
        },
        {
          id: 6,
          name: "Орео печенье",
          barcode: "9876543210003",
          total: 20,
          dateTime: "2024-03-12T16:00:00Z"
        }
      ]
    },
    {
      id: 3,
      name: "АГЗС Z-6",
      barcode: "1234567890123",
      status: "PROCESSED",
      statusLabel: "Доставлено",
      adress: "г. Астана, ул. Сарыарка, 10",
      createdAt: "2024-03-01",
      deliveryDate: "2024-03-10",
      data: [
        {
          id: 7,
          name: "Минеральная вода Borjomi",
          barcode: "1234567890001",
          total: 45,
          dateTime: "2024-03-10T12:00:00Z"
        },
        {
          id: 8,
          name: "Йогурт Чудо",
          barcode: "1234567890002",
          total: 30,
          dateTime: "2024-03-10T12:15:00Z"
        },
        {
          id: 9,
          name: "Энергетик Red Bull",
          barcode: "1234567890003",
          total: 25,
          dateTime: "2024-03-10T12:30:00Z"
        }
      ]
    },{
        id: 1,
        name: "АЗК Z-27",
        barcode: "1112223334445",
        status: "PROCESSED",
        statusLabel: "Доставлено",
        adress: "г. Астана, ул. Абая, 25",
        createdAt: "2024-03-07",
        deliveryDate: "2024-03-20",
        data: [
          { id: 1, name: "Сникерс", barcode: "1112223334445", total: 50, dateTime: "2024-03-15T09:45:00Z" },
          { id: 2, name: "Кока-Кола 0.5л", barcode: "1112223334446", total: 100, dateTime: "2024-03-15T09:50:00Z" },
          { id: 3, name: "Чипсы Lays", barcode: "1112223334447", total: 30, dateTime: "2024-03-15T10:00:00Z" }
        ]
      },
      {
        id: 2,
        name: "АЗК Z-26",
        barcode: "9876543210987",
        status: "PROCESSED",
        statusLabel: "Доставлено",
        adress: "г. Астана, пр. Туран, 50",
        createdAt: "2024-03-05",
        deliveryDate: "2024-03-15",
        data: [
          { id: 4, name: "Баунти", barcode: "9876543210987", total: 40, dateTime: "2024-03-12T15:30:00Z" },
          { id: 5, name: "Фанта 0.5л", barcode: "9876543210988", total: 90, dateTime: "2024-03-12T15:40:00Z" },
          { id: 6, name: "Орешки", barcode: "9876543210989", total: 25, dateTime: "2024-03-12T16:00:00Z" }
        ]
      },
      {
        id: 3,
        name: "АГЗС Z-6",
        barcode: "1234567890123",
        status: "PROCESSED",
        statusLabel: "Доставлено",
        adress: "г. Астана, ул. Сарыарка, 10",
        createdAt: "2024-03-01",
        deliveryDate: "2024-03-10",
        data: [
          { id: 7, name: "Твикс", barcode: "1234567890123", total: 35, dateTime: "2024-03-10T12:00:00Z" },
          { id: 8, name: "Спрайт 0.5л", barcode: "1234567890124", total: 80, dateTime: "2024-03-10T12:15:00Z" },
          { id: 9, name: "Попкорн", barcode: "1234567890125", total: 20, dateTime: "2024-03-10T12:30:00Z" }
        ]
      },
      {
        id: 4,
        name: "АЗК Z-27",
        barcode: "3216549870123",
        status: "PROCESSED",
        statusLabel: "Доставлено",
        adress: "г. Астана, ул. Кенесары, 33",
        createdAt: "2024-03-08",
        deliveryDate: "2024-03-18",
        data: [
          { id: 10, name: "Марс", barcode: "3216549870123", total: 45, dateTime: "2024-03-18T09:00:00Z" },
          { id: 11, name: "Пепси 0.5л", barcode: "3216549870124", total: 95, dateTime: "2024-03-18T09:15:00Z" },
          { id: 12, name: "Крекеры", barcode: "3216549870125", total: 15, dateTime: "2024-03-18T09:30:00Z" }
        ]
      },
      {
        id: 5,
        name: "АЗК Z-26",
        barcode: "4567891236547",
        status: "PROCESSED",
        statusLabel: "Доставлено",
        adress: "г. Астана, пр. Богенбай батыра, 77",
        createdAt: "2024-03-02",
        deliveryDate: "2024-03-12",
        data: [
          { id: 13, name: "Баунти", barcode: "4567891236547", total: 50, dateTime: "2024-03-12T14:00:00Z" },
          { id: 14, name: "Лимонад", barcode: "4567891236548", total: 70, dateTime: "2024-03-12T14:20:00Z" },
          { id: 15, name: "Круассаны", barcode: "4567891236549", total: 25, dateTime: "2024-03-12T14:40:00Z" }
        ]
      }
  ];
  
  export default mockAdmin;